import React, { createContext, ReactNode, useContext } from 'react';
import { useAuth } from './AuthContext';

interface SessionContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  user: any | null;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

const SessionContext = createContext<SessionContextType>({
  isAuthenticated: false,
  isLoading: true,
  user: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  login: async () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  logout: async () => {},
});

export const useSession = (): SessionContextType => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};

interface SessionProviderProps {
  children: ReactNode;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user, login, logout } = useAuth();

  // You can add additional session management logic here
  // For example, checking token expiration, refreshing tokens, etc.

  const value: SessionContextType = {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout,
  };

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};
